import { Box, Button } from "@mui/material";
import { Add } from "@mui/icons-material";
import { styled } from "@mui/system";
import IntlMessages from "../IntlMessages/IntlMessages";
interface AddStepProps {
  onAddStep(): void;
}
//#region style
const AddStepContainer = styled(Box)(({ theme }) => ({
  border: "1px dashed #aaa",
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  textAlign: "center",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  margin: "0 auto",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  color: theme?.palette?.text?.secondary,
  fontSize: "16px",
  fontWeight: 500,
  textTransform: "none",
  backgroundColor: "transparent",
  border: "none",
  outline: "none",
  "&:hover, &:focus, &:active, &:visited, &:focus-visible": {
    backgroundColor: "transparent",
    borderWidth: 0,
    outline: 0,
  },
}));
//#endregion

const AddStep = ({ onAddStep }: AddStepProps) => {
  return (
    <AddStepContainer
      id="addStepContainer"
      data-testid="addStepContainer"
      onMouseDown={onAddStep}
    >
      <StyledButton
        id="addStepButton"
        data-testid="addStepButton"
        startIcon={<Add />}
      >
        <IntlMessages id="steps.addStep.button" />
      </StyledButton>
    </AddStepContainer>
  );
};
export { AddStep };
